import React, { useCallback, useState } from 'react';
import { Layout, PageHeader, Space } from 'antd';
import { QueryKey } from 'api/queryKey';
import { Content } from 'common/StyledComponents';
import { useQuery, useQueryCache } from 'react-query';
import { UsersAPI } from 'api/UsersAPI';
import { Doctor } from 'models/doctor';
import Column from 'antd/lib/table/Column';
import { UserStatusTag } from 'common/components/UserStatusTag';
import { UserStatus } from 'models/userStatus';
import { DeleteDoctorButton } from 'pages/SuperAdminModule/DoctorsPage/DeleteDoctorButton';
import { commonPaginationConfig, initialPageParams } from 'models/page';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { NumberedTable } from 'common/components/NumberedTable';
import { toSimpleDate } from 'common/dateFnsUtils';
import { CloseOutlined } from '@ant-design/icons/lib';

export const DoctorsPage = () => {
  const queryCache = useQueryCache();
  const [pageMetaData, setPageMetaData] = useState(initialPageParams);
  const intlMessage = useFormatMessage();

  const { data, isFetching } = useQuery(
    [QueryKey.Doctors, pageMetaData],
    () => UsersAPI.fetchDoctors(pageMetaData),
    {
      keepPreviousData: true,
    }
  );

  const invalidateDoctors = useCallback(
    () => queryCache.invalidateQueries(QueryKey.Doctors),
    [queryCache]
  );

  const paginationConfig = {
    ...commonPaginationConfig,
    current: pageMetaData?.page,
    pageSize: data?.size,
    total: data?.totalElements,
    onChange: (page: number, pageSize?: number) =>
      setPageMetaData((prev) => ({
        ...prev,
        page,
        ...(pageSize && { pageSize }),
      })),
  };

  return (
    <Layout>
      <Content>
        <PageHeader title={intlMessage({ id: 'doctors' })} />
        <NumberedTable
          rowKey="id"
          loading={isFetching}
          dataSource={data?.content}
          pagination={paginationConfig}
          scroll={{ x: 'auto' }}
        >
          <Column
            title={intlMessage({ id: 'name' })}
            key="firstName"
            render={
              (value, record: Doctor) =>
                // <Link
                //   key={`${url}/${record.userId}`}
                //   to={`${url}/${record.userId}`}
                // >
                `${record.firstName} ${record.lastName}`
              // </Link>
            }
          />
          <Column title="Email/Login" dataIndex="email" />
          <Column
            title={intlMessage({ id: 'create_date' })}
            dataIndex="createDate"
            render={(value) => toSimpleDate(value)}
          />
          <Column
            title={intlMessage({ id: 'familyUsers.lastLogin' })}
            dataIndex="lastLoginDate"
            render={(value) => (value === null ? '--' : toSimpleDate(value))}
          />
          <Column
            title={intlMessage({ id: 'partner' })}
            dataIndex={['partnerDetails', 'name']}
            align="center"
            render={(value) => value || <CloseOutlined />}
          />
          <Column
            title={intlMessage({ id: 'status' })}
            dataIndex="status"
            render={(value) => <UserStatusTag status={value} />}
          />
          <Column
            title={intlMessage({ id: 'actions' })}
            key="actions"
            align="right"
            render={(value, record: Doctor) => (
              <Space>
                {record.status !== UserStatus.Archived && (
                  <DeleteDoctorButton
                    doctor={record}
                    onDeleted={invalidateDoctors}
                  />
                )}
              </Space>
            )}
          />
        </NumberedTable>
      </Content>
    </Layout>
  );
};
